import axios from 'axios';
import { DHLError, handleHttpResponse } from '@general/js/utils';
import AbstractClass from './SupportAbstractServices';
import { Services } from '../Services';

export default class SupportServices extends AbstractClass {
  /**
   * Get reference data of member portal contact us page
   * @returns {object}
   */
  static async getContactUsReferenceData() {
    try {
      const response = await axios.get(Services.SUPPORT.CONTACT_US.GET_REFERENCE_DATA);

      if (handleHttpResponse(response)) {
        // return member number string token swapped data
        return JSON.parse(JSON.stringify(response.data).tokenSwap());
      }

      throw new DHLError(`Unexpected data structure returned for data: ${JSON.stringify(response.data)}`);
    } catch (error) {
      throw new DHLError(`getContactUsReferenceData() - call failed with error: ${JSON.stringify(error.message)}`, error);
    }
  }

  /**
   * Get related articles reference data for member portal contact us confirmation page
   * @returns {object}
   */
  static async getContactUsConfirmationReferenceData() {
    try {
      const response = await axios.get(Services.SUPPORT.CONTACT_US.GET_CONFIRMATION_REFERENCE_DATA);

      if (handleHttpResponse(response)) {
        // return member number string token swapped data
        return JSON.parse(JSON.stringify(response.data).tokenSwap());
      }

      throw new DHLError(`Unexpected data structure returned for data: ${JSON.stringify(response.data)}`);
    } catch (error) {
      throw new DHLError(`getContactUsConfirmationReferenceData() - call failed with error: ${JSON.stringify(error.message)}`, error);
    }
  }
}
